
export const ApplicantCallIcon = ({
    primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_43103"
        data-name="Group 43103"
        transform="translate(-1226 -163)"
      >
        <circle
          id="Ellipse_1238"
          data-name="Ellipse 1238"
          cx="24"
          cy="24"
          r="24"
          transform="translate(1226 163)"
          fill={primaryColor}
        />
        <g id="phone-call" transform="translate(1240.164 178)">
          <g
            id="Group_41511"
            data-name="Group 41511"
            transform="translate(0.539 0)"
          >
            <path
              id="Path_63874"
              data-name="Path 63874"
              d="M18.645,13.675l-2.6-2.6a1.729,1.729,0,0,0-2.879.65,1.77,1.77,0,0,1-2.043,1.114A8.018,8.018,0,0,1,6.294,8.01,1.683,1.683,0,0,1,7.408,5.967a1.729,1.729,0,0,0,.65-2.879l-2.6-2.6a1.855,1.855,0,0,0-2.507,0L1.186,2.252C-.578,4.109,1.372,9.031,5.737,13.4s9.287,6.408,11.144,4.55l1.764-1.764A1.855,1.855,0,0,0,18.645,13.675Z"
              transform="translate(-0.539 0)"
              fill={secondColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
